import { loadBaseCSS } from '../shared/button-utils.js';
import { primitiveStyles } from '../shared/primitive-utils.js';

/**
 * Decorative placeholder reserving its final layout dimensions. Announce loading on the surrounding region.
 * @element qds-skeleton
 * @attr {'text'|'rectangle'|'circle'} shape - Placeholder shape. Default text.
 * @attr {boolean} static - Disable the pulse even when motion is allowed.
 * @cssprop --qds-skeleton-width - Reserved width, default 100%.
 * @cssprop --qds-skeleton-height - Reserved height, default 1em (circle 3rem).
 * @csspart placeholder - Decorative pulse surface.
 */
export class QdsSkeleton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' }).innerHTML = `<style>${primitiveStyles}
      :host { display: block; width: var(--qds-skeleton-width, 100%); height: var(--qds-skeleton-height, 1em); }
      :host([shape="circle"]) { width: var(--qds-skeleton-width, 3rem); height: var(--qds-skeleton-height, 3rem); }
      [part="placeholder"] { width: 100%; height: 100%; border-radius: 4px; background: var(--theme-border-primary, #e4e9f2); animation: pulse 1.5s ease-in-out infinite alternate; }
      :host([shape="circle"]) [part="placeholder"] { border-radius: 50%; }
      :host([shape="rectangle"]) [part="placeholder"] { border-radius: var(--theme-radius-md, 8px); }
      :host([static]) [part="placeholder"] { animation: none; }
      @keyframes pulse { to { opacity: .45; } }
      @media (prefers-reduced-motion: reduce) { [part="placeholder"] { animation: none; } }
      @media (forced-colors: active) { [part="placeholder"] { border: 1px solid GrayText; } }
    </style><div part="placeholder" aria-hidden="true"></div>`;
    loadBaseCSS();
  }
  connectedCallback(): void { this.setAttribute('aria-hidden', 'true'); }
}
if (!customElements.get('qds-skeleton')) customElements.define('qds-skeleton', QdsSkeleton);
